export default "/images/shildikMegogo.svg?e18f4089d78638ba70742785fba700b4";